import { GET_VENDOR_INFO } from "../arsVariables";

const getVendorInfo = payload => ({
    type: GET_VENDOR_INFO,
    payload
});

export default getVendorInfo;
